import { ParsedUrlQuery } from 'querystring';
import {
    getCalculatedDateFilter,
    getHouseTypeString,
    getNumMonthsString
} from '.';

export const PAGE_SIZE = 10;

export const getSearchPropertiesQueryVariables = (
    query: ParsedUrlQuery,
    geoIdentifier: string
) => {
    const page = parseInt(query.pn as string, 10);
    const after = !isNaN(page) ? (page - 1) * PAGE_SIZE : null;
    const sortDirection = (query?.sortDirection as string) || 'desc';
    const sortOrder = (query?.sortOrder as string) || 'last_sale_date';
    const toLastSaleDate = query?.toLastSaleDate as string;
    const fromLastSaleDate = getCalculatedDateFilter(
        parseInt(query?.numMonths as string),
        Date.now()
    );
    const propertyTypeCode = query?.propertyTypeCode as string;

    const variables = {
        geoIdentifier: geoIdentifier.toLowerCase(),
        after: after?.toString() ?? '0',
        first: PAGE_SIZE,
        sortOrder,
        fromLastSaleDate,
        propertyTypeCode,
        sortDirection,
        toLastSaleDate
    };
    return variables;
};

export const getAdditionalHousePricesQueryVariables = (
    query: ParsedUrlQuery,
    searchPath?: string | string[]
) => {
    const searchQuery = query.q;
    const propertyTypeCode = query?.propertyTypeCode as string;
    const houseType = getHouseTypeString(propertyTypeCode);
    const rangeMonthsString = getNumMonthsString(query?.numMonths as string);

    const variables = {
        path: `/house-prices/${
            Array.isArray(searchPath) ? searchPath.join('/') : searchPath
        }/?q=${searchQuery}&search_source=house-prices`,
        geoString: searchQuery?.toString() || undefined,
        houseType: houseType,
        rangeMonths: rangeMonthsString
    };
    return variables;
};

export const getGeoIdentifier = (searchPath?: string | string[]) => {
    const geoIdentifier = searchPath
        ? Array.isArray(searchPath)
            ? searchPath.join('/')
            : searchPath
        : '';

    return geoIdentifier;
};
